import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {AddDriveDialogComponent} from '../component/add-drive-dialog/add-drive-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})

export class CreateTeamDriveCommandHandler implements IPlatformCommandHandler {
  constructor(
    protected dialog: MatDialog,
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const dialogRef = this.dialog.open(AddDriveDialogComponent, {
      minWidth: '600px',
      maxWidth: '600px',
      disableClose: true
    });
    dialogRef.afterClosed().pipe().subscribe((driveName: string) => {
      if (driveName) {
        command.fieldValues['DriveName'] = driveName;
        handler.executeCommand(command);
      }
    });
    return true;
  }
}
